"use client";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useState, type ReactNode } from "react";
import { PlatformError } from "./client";

/* One client per browser session. Created in state rather than at module
   scope so a server render never shares a cache between requests. */
export function QueryProvider({ children }: { children: ReactNode }) {
  const [client] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 30_000,
            refetchOnWindowFocus: false,
            retry: (failureCount, error) => {
              /* 401 and 403 mean "not signed in" and "origin not allowed" —
                 neither improves by asking again. */
              if (!(error instanceof PlatformError) || !error.isTransient) {
                return false;
              }

              return failureCount < 2;
            },
          },
        },
      }),
  );

  return <QueryClientProvider client={client}>{children}</QueryClientProvider>;
}
